import { Component, OnInit } from '@angular/core';
import { RequisitionExceptionDataService } from '../../data-services/requisitionException.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem, MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-resolvedException-list',
  templateUrl: './resolved.list.html',
  providers: [MessageService],
  imports: [Toast, CommonModule, TableModule, RouterModule]
})
export class ResolvedExceptionListComponent implements OnInit {

  constructor(private requisitionExceptionDataService: RequisitionExceptionDataService,
    private messageService: MessageService) {
  }

  requisitionExceptions;
  statuses: SelectItem[] = [];
  facilities: SelectItem[] = [];
  testNames: SelectItem[] = [];
  totalRecords: number;
  cols: any[];
  loading: boolean;
  selectedStatus: SelectItem;
  showSpinner: boolean = false;
  editRequisitionModalVisible: boolean = false;

  ngOnInit() {

    this.cols = [
      { field: 'Accession', header: 'Accession' },
      { field: 'PatientFullName', header: 'Patient' },
      { field: 'PackageReceivedOn', header: 'Received Date' },
      { field: 'ClientName', header: 'Client' },
      { field: 'ResolvedBy', header: 'Resolved By' },
      { field: 'ResolvedDate', header: 'Resolved Date' },
      { field: 'RackSerialNumber', header: 'Rack' },
      { field: 'RackLocationName', header: 'Location' },
      { field: 'StatusText', header: 'Status' }
    ];
    this.loading = true;
  }

  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      reqlist.filterGlobal(event.target.value, 'contains');
      event.preventDefault();
    }
  }

  public onDateSelect(event, reqlist, fieldName) {
    reqlist.filter(this.formatDate(event.target.value), fieldName, 'equals')
  }

  formatDate(date) {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = '0' + month;
    }

    if (day < 10) {
      day = '0' + day;
    }

    return date.getFullYear() + '-' + month + '-' + day;
  }

  applyFilter() {
    this.loadRequisitionExceptionsLazy(null);
  }

  lastLoad: any;
  public loadRequisitionExceptionsLazy(event: LazyLoadEvent) {
    this.loading = true;
    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.requisitionExceptionDataService.getResolvedList(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.requisitionExceptions = data.rows;
      this.loading = false;
    });
  }

  public removeToast() {
    this.messageService.clear();
  }
}
